/**
 * CUSTOMIZATIONS:
 * - Nascosto il titoletto in alto se il flag "Nascondi" è attivo
 * - Aggiunta customizzazione per il titoletto e il link nello slimHeader (configurazione di sinistra parentSiteTitle, parentSiteURL e HeaderBrandCondition)
 *
 * HeaderSlim component.
 * @module components/ItaliaTheme/Header/HeaderSlim
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { HeaderSlimRightZone } from 'design-comuni-plone-theme/components/ItaliaTheme';
import {
  Header,
  HeaderBrand,
  HeaderContent,
  HeaderRightZone,
} from 'design-react-kit';
import { useIntl } from 'react-intl';
import {
  getSiteProperty,
  useHomePath,
} from 'design-comuni-plone-theme/helpers';
import { SiteProperty } from 'volto-site-settings';

const HeaderSlim = () => {
  const subsite = useSelector((state) => state.subsite?.data);
  const intl = useIntl();
  const homepath = useHomePath();
 
  let slimHeaderLabel = SiteProperty({ property: 'header_label', getValue: true })?.[intl.locale];
  let slimHeaderUrl = SiteProperty({ property: 'header_link', getValue: true })?.[intl.locale];

  let parentSiteURL = subsite
    ? homepath
    : (slimHeaderLabel && slimHeaderUrl) 
    ? slimHeaderUrl 
    : getSiteProperty('parentSiteURL', intl.locale);

  const configuredParentSiteTitle = slimHeaderLabel ?? getSiteProperty('parentSiteTitle', intl.locale);

  const parentSiteTitle = SiteProperty({
    property: 'site_title',
    forceValue: subsite ? null : configuredParentSiteTitle,
    defaultValue: configuredParentSiteTitle,
    getValue: true,
    getParent: true,
  });

  const hideHeaderLabel = SiteProperty({
    property: 'hide_header_label',
    defaultValue: false,
    getValue: true,
    getParent: false,
  });

  const target = subsite ? null : '_blank';

  const HeaderBrandCondition = (slimHeaderLabel && !slimHeaderUrl) ? (
    <div className='navbar-brand'>
      {/* Only label */}
      {slimHeaderLabel}
    </div>
    ) : (
    <HeaderBrand
      responsive
      href={parentSiteURL}
      target={target}
      rel="noopener noreferrer"
    >
      {parentSiteTitle}
    </HeaderBrand>
  );

  return (
    <Header small={false} theme="" type="slim" role="navigation">
      <HeaderContent>
        {!hideHeaderLabel && HeaderBrandCondition}
        <HeaderRightZone className="ms-auto">
          <HeaderSlimRightZone />
        </HeaderRightZone>
      </HeaderContent>
    </Header>
  );
};

export default HeaderSlim;
